// extracted by mini-css-extract-plugin
module.exports = {"formClass":"sM","setupPinButton":"sN","submitButton":"sO","cancelButton":"sP","enterPinHelpText":"sQ"};